import Marionette from "backbone.marionette";
import templates from "../../../utils/templates";
import PopoverBehavior from "../../../behaviors/popover";

const EmptyView = Marionette.ItemView.extend({
  template: templates.find("chart_reviews", "chart_edit_meta_no_data"),
});

const Item = Marionette.ItemView.extend({
  tagName: "li",
  className: "list-group-item condensed",
  template: templates.find(
    "chart_reviews",
    "chart_edit_meta_categories_list_item"
  ),
  behaviors: [
    {
      behaviorClass: PopoverBehavior,
      opts: {
        html: true,
        placement: "auto left",
      },
    },
  ],
});

const List = Marionette.CollectionView.extend({
  tagName: "ul",
  className: "list-group",
  childView: Item,
  emptyView: EmptyView,
});

const DEFAULTS = {
  className: "form-group card",
  template: templates.find("chart_reviews", "chart_edit_meta_categories_list"),
};

class MemberCategories extends Marionette.LayoutView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  regions() {
    return {
      list: ".member-categories-list",
    };
  }

  onBeforeShow() {
    this.list.show(
      new List({
        collection: this.model.get("data"),
      })
    );
  }
}

export { MemberCategories as default };
